import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { AuthService } from './auth.service';
import { AwsService } from '../service/aws.service';
import { environment } from '../../environments/environment';
import { AwsCommonService } from '../service/aws-common.service';
import { takeUntil } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

declare var $: any;

@Injectable({
    providedIn: 'root'
})

export class authManager implements CanActivate {
    accessToken: string;
    idToken: string;
    tokenType: string;
    storedAccessTokenIssueDate = sessionStorage.getItem('access_token_issuedate');
    accessTokenIssueDate = new Date(this.storedAccessTokenIssueDate);
    accessTokenTimeoutDate: Date = this.accessTokenIssueDate;
    tokenTimeoutMins = 120;
    public dynSSOId = '-1';
    currentDate = new Date();
    state_key: any;
    nonce_key: any;
    code: string;
    from: string;
    emailurl: string;    
    isValidUser: boolean = false;
    destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private authService: AuthService, private awsService: AwsService, private http: HttpClient, private awsCommonService: AwsCommonService,
        private cookieService: CookieService) {        
        this.accessToken = this.getUrlVars('#')['access_token'];
        this.tokenType = this.getUrlVars('#')['token_type'];
        this.idToken = this.getUrlVars('#')['id_token'];
        // MIGR00302 PKCE: authorization code arrives in query params, not the hash fragment.
        this.code = new URLSearchParams(window.location.search).get('code') || '';
        this.from = this.getUrlVars('?')['from'];       
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
            // MIGR00302: read code only from instance var and window.location — NOT
            // from route.queryParams because Angular's internal router state retains the
            // original ?code= snapshot even after replaceState, causing AADSTS54005 when
            // isUserAdmin() navigates to /flashreport and re-fires this guard.
            // Also skip exchange entirely if we already stored tokens (guard re-fire guard).
            const alreadyAuthenticated = !!sessionStorage.getItem('access_token');
            const code = alreadyAuthenticated
                ? ''
                : (this.code || new URLSearchParams(window.location.search).get('code') || '');
            console.log('[MFR auth] canActivate | code:', code ? 'PRESENT' : 'MISSING',
                        '| window.search:', window.location.search.substring(0, 40),
                        '| pkce(ss):', !!sessionStorage.getItem('pkce_verifier'),
                        '| pkce(ls):', !!localStorage.getItem('pkce_verifier'),
                        '| access_token:', !!sessionStorage.getItem('access_token'));

            if (code) {
                // MIGR00302: clear immediately — Entra codes are single-use.
                // Must happen synchronously before any async call so a re-fired guard
                // (Angular navigation event, Cognito error retry, etc.) cannot re-submit
                // the same code and get AADSTS54005 "already redeemed".
                this.code = '';
                window.history.replaceState({}, document.title, window.location.pathname);
                // MIGR00302: PKCE callback — exchange the authorization code for tokens,
                // then complete the same AWS/Cognito setup as the old implicit flow did.
                return this.exchangeCodeForTokens(code)
                .then(tokens => {
                    sessionStorage.setItem('access_token', tokens.access_token);
                    sessionStorage.setItem('id_token', tokens.id_token);
                    sessionStorage.removeItem('pkce_verifier');
                    localStorage.removeItem('pkce_verifier');
                    return this.awsService.authenticatefss(null, tokens.id_token).then(result => {
                        console.log(result);
                        return this.awsCommonService.postRequest(`${environment.apiUrl}Report/userdetail`, 'POST', tokens.access_token).pipe(takeUntil(this.destroy$)).toPromise().then((userresult: any) => {
                            userresult = JSON.parse(userresult);
                            if (userresult === 'ERROR') return false;
                            sessionStorage.setItem('SSO', userresult['access_token']['uid']);
                            sessionStorage.setItem('FirstName', userresult['access_token']['FirstName']);
                            this.isUserAdmin();
                            return true;
                        });
                    });
                }).catch(err => {
                    console.error('[MFR auth] token exchange failed:', err);
                    this.code = ''; // prevent retry with expired code
                    this.router.navigate(['/autherror']);
                    return false;
                });
            } else if (this.idToken !== null && this.idToken !== undefined) {                                
                if (!sessionStorage.getItem('sessionToken')) {
                    sessionStorage.setItem('access_token', this.accessToken);
                    sessionStorage.setItem('id_token', this.idToken);
                    console.log(this.idToken);
                    console.log(this.code);
                    console.log(this.from);
                    console.log(environment.apiUrl);
                    return this.awsService.authenticatefss(null, sessionStorage.getItem('id_token')).then(result => {                                                 
                       console.log(result);
                        this.awsCommonService.postRequest(`${environment.apiUrl}Report/userdetail`, 'POST', sessionStorage.getItem('access_token')).pipe(takeUntil(this.destroy$)).subscribe((userresult: any) => {                                                        
                            userresult = JSON.parse(userresult);                            
                            if (userresult == "ERROR") {
                                //this.router.navigate(['/error']);
                                return false;
                            } else {
                                  
                                sessionStorage.setItem('SSO', userresult['access_token']['uid']);
                                sessionStorage.setItem('FirstName', userresult['access_token']['FirstName']);
                                this.isUserAdmin();
                                return true;

                                // else
                                // {
                                //     this.router.navigate(['/autherror']);
                                // }
                            }
                        });
                    }).catch((error) => {
                        console.log(error); //this.router.navigate(['/error']); 
                    });
                } else {
                    return true;
                }
            } else if (sessionStorage.getItem('access_token') && !sessionStorage.getItem('sessionToken')) {                
                return this.awsService.authenticatefss(null, sessionStorage.getItem('id_token')).then(result => {                                         
                    this.awsCommonService.postRequest(`${environment.apiUrl}Report/userdetail`, 'POST', sessionStorage.getItem('access_token')).pipe(takeUntil(this.destroy$)).subscribe((userresult: any) => {                        
                        userresult = JSON.parse(userresult);
                        if (userresult == 1) {
                            //this.router.navigate(['/autherror']);
                            return false;
                        } else {
                            sessionStorage.setItem('SSO', userresult['access_token']['uid']);
                            sessionStorage.setItem('FirstName', userresult['access_token']['FirstName']);
                        }
                    });
                }).catch((error) => { console.log(error); this.router.navigate(['/error']); });
            } else if (sessionStorage.getItem('sessionToken') && !sessionStorage.getItem('SSO')) {                                
                this.awsCommonService.postRequest(`${environment.apiUrl}Report/userdetail`, 'POST', sessionStorage.getItem('access_token')).pipe(takeUntil(this.destroy$)).subscribe((userresult: any) => {                      
                    userresult = JSON.parse(userresult);
                    if (userresult == "ERROR") {
                        //this.router.navigate(['/autherror']);
                        return false;
                    } else {
                        sessionStorage.setItem('SSO', userresult['access_token']['uid']);
                        sessionStorage.setItem('FirstName', userresult['access_token']['FirstName']);
                    }
                });
            } else if (sessionStorage.getItem('sessionToken') && sessionStorage.getItem('SSO')) {                                  
                if((sessionStorage.getItem('IsAdminAccess') == '0' && !(window.location.href.indexOf('viewreports') > 0)) 
                ) {
                    this.router.navigate(['/autherror']);
                    return false;
                }
                else if (sessionStorage.getItem('IsAdminAccess') == 'null')
                {
                    this.router.navigate(['/autherror']);
                    return false;
                }
                else {
                    return true;
                }
            } else if (!sessionStorage.getItem('access_token')) {
                  
                sessionStorage.setItem('referenceUrl', window.location.href);
                // MIGR00302: Standard auth-code flow — the backend exchanges the code
                // with client_secret (POST /Report/auth/token), so no PKCE needed here.
                window.location.replace(
                    environment.entraAuthorizeUrl +
                    '?client_id=' + encodeURIComponent(environment.entraClientId) +
                    '&response_type=code' +
                    '&redirect_uri=' + encodeURIComponent(environment.appurl) +
                    '&scope=openid+email+profile' +
                    '&response_mode=query'
                );
            } else {
                return new Observable<any>();
            }
        
    }
    getUrlVars(code) {        
        var vars = [];
        var hash;
        var hashes = window.location.href.slice(window.location.href.indexOf(code) + 1).split('&'); 
        if(window.location.href == environment.appurl + "viewreports?from=email")
        {        
        this.cookieService.set( 'emailURL', environment.appurl + "viewreports?from=email" );
        } 
        else if(window.location.href == environment.appurl + "publishreportstest")
        {
            this.cookieService.set('testURL', environment.appurl + "publishreportstest");
        }
        for (let i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    logoutUser() {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = environment.logoutUrl;
    }

    isUserAdmin() {          
        return this.awsCommonService.getApiRequest(`${environment.apiUrl}Report/User/IsAdmin/` + sessionStorage.getItem('SSO'), 'GET').pipe(takeUntil(this.destroy$)).subscribe((userresult: any) => {            
            sessionStorage.setItem('IsAdminAccess', userresult);
            if (sessionStorage.getItem('IsAdminAccess') == '1') { 
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                    this.router.navigate(['viewreports']);
                    sessionStorage.setItem('MobileView', '0');
                   }   
                   else if (this.cookieService.get('emailURL') == environment.appurl + "viewreports?from=email")
                   {
                    this.router.navigate(['viewreports']);                    
                   }
                   else if (this.cookieService.get('testURL') == environment.appurl + "publishreportstest")
                   {
                    this.router.navigate(['publishreportstest']);                    
                   }
                   else{                                                  
                this.router.navigate(['flashreport']); 
                sessionStorage.setItem('MobileView', '1'); 
                   }               
            }
            else if (sessionStorage.getItem('IsAdminAccess') == '0') {                                       
                this.router.navigate(['viewreports']);                                     
            }  
            else
            {
                this.router.navigate(['autherror']);
            }          
        });
    }

    // ── MIGR00302: PKCE helpers ──────────────────────────────────────────────────

    private generateCodeVerifier(): string {
        const array = new Uint8Array(96);
        window.crypto.getRandomValues(array);
        return btoa(String.fromCharCode(...Array.from(array)))
            .replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }

    private generateCodeChallenge(verifier: string): Promise<string> {
        const data = new TextEncoder().encode(verifier);
        return (window.crypto.subtle.digest('SHA-256', data) as Promise<ArrayBuffer>).then(digest =>
            btoa(String.fromCharCode(...Array.from(new Uint8Array(digest))))
                .replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
        );
    }

    private exchangeCodeForTokens(code: string): Promise<any> {
        // MIGR00302: POST the auth code to our own backend, which exchanges it with
        // the client_secret server-side and returns { access_token, id_token, ... }.
        // This keeps the client_secret off the browser entirely.
        return this.http.post<any>(`${environment.apiUrl}Report/auth/token`, {
            code: code,
            redirectUri: environment.appurl
        }).toPromise();
    }
  
}
